// componentes/AnimacionPagina.js
import { motion } from 'framer-motion';

const AnimacionPagina = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}   
      animate={{ opacity: 1, y: 0 }}    
      exit={{ opacity: 0, y: 50 }}     
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  );
};

export default AnimacionPagina;